module.exports = __webpack_public_path__ + "img/zignaly.9e5112ae.svg";